import { createAsyncThunk } from '@reduxjs/toolkit';
import { dayJS } from "../../applicationConf";
import new_axios_instance from '../../axios_instance';
import { TAB_ENUM_INDIVIDUI_TARGET } from "../../costanti";
import { createMessageRequestException, printOnlyInDevelopment } from "../../fanctionUtility";
import { getValidazioniMonitoraggioLogSuccess, removeValidationSuccess, ricercaValidazioniSuccess, validaSuccess } from '../../slices/validazioneSlice';
import * as types from '../actionsTypes/validazioneActionType';
import { loadingOverlayActions, notifsActions } from "../index";


/******************* Validazione mese singolo Individuo **********************/

export const valida = (objDaValidare, navigate, tab,backPath) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(validaAction());
    objDaValidare.mese = objDaValidare.mese.substring(0, 7)
    await new_axios_instance.post(`/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/valida`, objDaValidare)
        .then(response => {

            dispatch(validaSuccess(response.data));
            const date = dayJS(objDaValidare.mese, 'YYYY-MM');

            dispatch(loadingOverlayActions.hideLoadingOverlay());
            dispatch(notifsActions.notifSuccess(`Validazione avvenuta con successo per il mese di ${date.format('MMMM').charAt(0).toUpperCase() + date.format('MMMM').slice(1).toLowerCase()} ${date.year()}`));
            sessionStorage.removeItem('validationCache')
            navigate(backPath)
        }).catch(error => {
            const message = createMessageRequestException(error);

            // dispatch(validaFail(message));
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());

            window.scrollTo({top: 0, behavior: "smooth"});
            document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"});
        });
};

//export for testing
export const validaAction = () => ({
    type: types.VALIDA_ACTION
});

/*const validaFail = error => {
    return {
        type: types.VALIDA_FAIL,
        error: error
    }
};*/

export const removeValidation = (payload) => ({
    type: types.REMOVE_VALIDATION,
    payload
});


/******************* Validazione mese singolo Individuo **********************/

/******************* Recupera mesi validati singolo Individuo ****************/

/*export const recuperaValidati = (param, tab) => async dispatch => {
    dispatch(recuperaValidatiAction());

    await new_axios_instance.get(`/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/ricerca/corso/${param.idCorso}/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/${param.idAnagrafica}/`)
        .then(response => {
            dispatch(recuperaValidatiSuccess(response.data, param.idAnagrafica));
        }).catch(error => {
            const message = createMessageRequestException(error);
            dispatch(recuperaValidatiFail({[param.idAnagrafica]: message}));
        });
};*/

// export for testing
/*export const recuperaValidatiAction = () => ({
    type: types.RECUPERA_VALIDATI_ACTION
});*/

/*const recuperaValidatiSuccess = (response) => {
    return {
        type: types.RECUPERA_VALIDATI_SUCCESS,
        mesiValidati: response
    }
};*/

/*const recuperaValidatiFail = (error) => {
    return {
        type: types.RECUPERA_VALIDATI_FAIL,
        error: error
    }
};*/

/******************* Recupera mesi validati singolo Individuo ****************/

/******************* Ricerca validazioni corso ******************************/

export const ricercaValidazioniCorso = (idCorso) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    await new_axios_instance.get(`/v1/corso/ricerca/validazioni/${idCorso}`)
        .then(response => {
            dispatch(ricercaValidazioniSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const message = createMessageRequestException(error);
            dispatch(notifsActions.notifError(message));

            // dispatch(ricercaValidazioniFail([message]));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
};

/*const ricercaValidazioniFail = (error) => {
    return {
        type: types.RICERCA_VALIDAZIONI_CORSO_FAIL,
        error: error
    }
};*/
/******************* Ricerca validazioni corso ******************************/

/******************* Valida mese corso **************************************/

export const validaMeseCorso = (requestValidity) => async dispatch => {

    await new_axios_instance.post(`/v1/corso/valida`, requestValidity)
        .then(() => {
            setTimeout(() => dispatch(ricercaValidazioniCorso(requestValidity.idCorso)), 200);
            dispatch(notifsActions.notifSuccess('Operazione avvenuta con successo'));
        })
        .catch(error => {
            const message = createMessageRequestException(error);

            dispatch(notifsActions.notifError(message));
            printOnlyInDevelopment(error);

            window.scrollTo({top: 0, behavior: "smooth"});
        })
};

/******************* Valida mese corso **************************************/

/******************* Recupero Validazioni per monitoraggio **************************************/

export const getValidazioniMonitoraggioLog = (param) => async dispatch => {

    dispatch(loadingOverlayActions.showLoadingOverlay());

    await new_axios_instance.post(`/v1/corso/ricerca/validazioniconfiltro`, param)
        .then(response => {
            dispatch(getValidazioniMonitoraggioLogSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const message = createMessageRequestException(error);

            dispatch(notifsActions.notifError(message));
            // dispatch(getValidazioniMonitoraggioLogFail([message]));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
}

/*export const getValidazioniMonitoraggioStart = () => ({
    type: types.GET_VALIDAZIONI_LOG
});*/



/*export const getValidazioniMonitoraggioLogFail = error => ({
    type: types.GET_VALIDAZIONI_LOG_FAIL,
    error
});*/

/******************* Recupero Validazioni per monitoraggio **************************************/

/******************* Elimina Validazione mese corso **************************************/

export const validazioneEliminaCorso = createAsyncThunk(
    'validazione/eliminaCorso',
    async ({idCorso, mese, motivazione}, thunkApi) =>
      await new_axios_instance.put(`/v1/corso/elimina/${idCorso}/validazione/mese/${mese}`, String(motivazione))
        .then(response => {
            thunkApi.dispatch(notifsActions.notifSuccess('Operazione avvenuta con successo'));
            thunkApi.dispatch(removeValidationSuccess())
            thunkApi.dispatch(loadingOverlayActions.showLoadingOverlay());
            thunkApi.dispatch(ricercaValidazioniCorso(idCorso));
            thunkApi.dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            const message = createMessageRequestException(error);
            thunkApi.dispatch(notifsActions.notifError(message));
        })
  )
/******************* Valida mese corso **************************************/



